module.exports = __webpack_public_path__ + "img/EMS_user_manual8.ed5cb092.png";